import purchaseOrderService from "../services/purchaseOrderService";

export const GET_PO_PRODUCT_LIST = "GET_PO_PRODUCT_LIST";
export const GET_PO_PRODUCT_LIST_SUCCESS = "GET_PO_PRODUCT_LIST_SUCCESS";
export const GET_PO_PRODUCT_LIST_ERROR = "GET_PO_PRODUCT_LIST_ERROR";

export const CREATE_PO = "CREATE_PO";
export const CREATE_PO_SUCCESS = "CREATE_PO_SUCCESS";
export const CREATE_PO_ERROR = "CREATE_PO_ERROR";
export const CREATE_PO_RESET = "CREATE_PO_RESET";

export const GET_PO_LIST = "GET_PO_LIST";
export const GET_PO_LIST_SUCCESS = "GET_PO_LIST_SUCCESS";
export const GET_PO_LIST_ERROR = "GET_PO_LIST_ERROR";

export const GET_GENERAL_PO_PRODUCT_LIST = "GET_GENERAL_PO_PRODUCT_LIST";
export const GET_GENERAL_PO_PRODUCT_LIST_SUCCESS =
  "GET_GENERAL_PO_PRODUCT_LIST_SUCCESS";
export const GET_GENERAL_PO_PRODUCT_LIST_ERROR =
  "GET_GENERAL_PO_PRODUCT_LIST_ERROR";
export const GET_GENERAL_PO_PRODUCT_LIST_RESET =
  "GET_GENERAL_PO_PRODUCT_LIST_RESET";

export const GET_PO_PRODUCTS_BY_PO_ID = "GET_PO_PRODUCTS_BY_PO_ID";
export const GET_PO_PRODUCTS_BY_PO_ID_SUCCESS =
  "GET_PO_PRODUCTS_BY_PO_ID_SUCCESS";
export const GET_PO_PRODUCTS_BY_PO_ID_ERROR = "GET_PO_PRODUCTS_BY_PO_ID_ERROR";
export const GET_PO_PRODUCTS_BY_PO_ID_RESET = "GET_PO_PRODUCTS_BY_PO_ID_RESET";

export const GET_PO_PRODUCTS_BY_SHOP_ID = "GET_PO_PRODUCTS_BY_SHOP_ID";
export const GET_PO_PRODUCTS_BY_SHOP_ID_SUCCESS =
  "GET_PO_PRODUCTS_BY_SHOP_ID_SUCCESS";
export const GET_PO_PRODUCTS_BY_SHOP_ID_ERROR =
  "GET_PO_PRODUCTS_BY_SHOP_ID_ERROR";
export const GET_PO_PRODUCTS_BY_SHOP_ID_RESET =
  "GET_PO_PRODUCTS_BY_SHOP_ID_RESET";

export const CREATE_RECEIVE_PO = "CREATE_RECEIVE_PO";
export const CREATE_RECEIVE_PO_SUCCESS = "CREATE_RECEIVE_PO_SUCCESS";
export const CREATE_RECEIVE_PO_ERROR = "CREATE_RECEIVE_PO_ERROR";
export const CREATE_RECEIVE_PO_RESET = "CREATE_RECEIVE_PO_RESET";

export const GET_PO_STORE_LOCATION = "GET_PO_STORE_LOCATION";
export const GET_PO_STORE_LOCATION_SUCCESS = "GET_PO_STORE_LOCATION_SUCCESS";
export const GET_PO_STORE_LOCATION_ERROR = "GET_PO_STORE_LOCATION_ERROR";
export const GET_PO_STORE_LOCATION_RESET = "GET_PO_STORE_LOCATION_RESET";

export const GET_RECEIVE_PO_LIST = "GET_RECEIVE_PO_LIST";
export const GET_RECEIVE_PO_LIST_SUCCESS = "GET_RECEIVE_PO_LIST_SUCCESS";
export const GET_RECEIVE_PO_LIST_ERROR = "GET_RECEIVE_PO_LIST_ERROR";

export const UPDATE_RECEIVE_PO = "UPDATE_RECEIVE_PO";
export const UPDATE_RECEIVE_PO_SUCCESS = "UPDATE_RECEIVE_PO_SUCCESS";
export const UPDATE_RECEIVE_PO_ERROR = "UPDATE_RECEIVE_PO_ERROR";
export const UPDATE_RECEIVE_PO_RESET = "UPDATE_RECEIVE_PO_RESET";

export const CREATE_PAYMENT_ADVICE = "CREATE_PAYMENT_ADVICE";
export const CREATE_PAYMENT_ADVICE_SUCCESS = "CREATE_PAYMENT_ADVICE_SUCCESS";
export const CREATE_PAYMENT_ADVICE_ERROR = "CREATE_PAYMENT_ADVICE_ERROR";
export const CREATE_PAYMENT_ADVICE_RESET = "CREATE_PAYMENT_ADVICE_RESET";

export const GET_SELLER_DATA_BY_SHOP_ID = "GET_SELLER_DATA_BY_SHOP_ID";
export const GET_SELLER_DATA_BY_SHOP_ID_SUCCESS =
  "GET_SELLER_DATA_BY_SHOP_ID_SUCCESS";
export const GET_SELLER_DATA_BY_SHOP_ID_ERROR =
  "GET_SELLER_DATA_BY_SHOP_ID_ERROR";
export const GET_SELLER_DATA_BY_SHOP_ID_RESET =
  "GET_SELLER_DATA_BY_SHOP_ID_RESET";

export const GET_PAYMENT_ADVICE_PRODUCTS = "GET_PAYMENT_ADVICE_PRODUCTS";
export const GET_PAYMENT_ADVICE_PRODUCTS_SUCCESS =
  "GET_PAYMENT_ADVICE_PRODUCTS_SUCCESS";
export const GET_PAYMENT_ADVICE_PRODUCTS_ERROR =
  "GET_PAYMENT_ADVICE_PRODUCTS_ERROR";
export const GET_PAYMENT_ADVICE_PRODUCTS_RESET =
  "GET_PAYMENT_ADVICE_PRODUCTS_RESET";

export const GET_VENDOR_PAYMENT_DETAILS = "GET_VENDOR_PAYMENT_DETAILS";
export const GET_VENDOR_PAYMENT_DETAILS_SUCCESS =
  "GET_VENDOR_PAYMENT_DETAILS_SUCCESS";
export const GET_VENDOR_PAYMENT_DETAILS_ERROR =
  "GET_VENDOR_PAYMENT_DETAILS_ERROR";
export const GET_VENDOR_PAYMENT_DETAILS_RESET =
  "GET_VENDOR_PAYMENT_DETAILS_RESET";

export const GET_PAYMENT_ADVICE_LIST = "GET_PAYMENT_ADVICE_LIST";
export const GET_PAYMENT_ADVICE_LIST_SUCCESS =
  "GET_PAYMENT_ADVICE_LIST_SUCCESS";
export const GET_PAYMENT_ADVICE_LIST_ERROR = "GET_PAYMENT_ADVICE_LIST_ERROR";
export const GET_PAYMENT_ADVICE_LIST_RESET = "GET_PAYMENT_ADVICE_LIST_RESET";

export const GET_APPROVAL_PAYMENT_ADVICE_LIST =
  "GET_APPROVAL_PAYMENT_ADVICE_LIST";
export const GET_APPROVAL_PAYMENT_ADVICE_LIST_SUCCESS =
  "GET_APPROVAL_PAYMENT_ADVICE_LIST_SUCCESS";
export const GET_APPROVAL_PAYMENT_ADVICE_LIST_ERROR =
  "GET_APPROVAL_PAYMENT_ADVICE_LIST_ERROR";
export const GET_APPROVAL_PAYMENT_ADVICE_LIST_RESET =
  "GET_APPROVAL_PAYMENT_ADVICE_LIST_RESET";

export const CREATE_RETURN_PO = "CREATE_RETURN_PO";
export const CREATE_RETURN_PO_SUCCESS = "CREATE_RETURN_PO_SUCCESS";
export const CREATE_RETURN_PO_ERROR = "CREATE_RETURN_PO_ERROR";
export const CREATE_RETURN_PO_RESET = "CREATE_RETURN_PO_RESET";

export const GET_RETURN_PO_LIST = "GET_RETURN_PO_LIST";
export const GET_RETURN_PO_LIST_SUCCESS = "GET_RETURN_PO_LIST_SUCCESS";
export const GET_RETURN_PO_LIST_ERROR = "GET_RETURN_PO_LIST_ERROR";

export const GET_VENDOR_ACCOUNT_DETAILS = "GET_VENDOR_ACCOUNT_DETAILS";
export const GET_VENDOR_ACCOUNT_DETAILS_SUCCESS =
  "GET_VENDOR_ACCOUNT_DETAILS_SUCCESS";
export const GET_VENDOR_ACCOUNT_DETAILS_ERROR =
  "GET_VENDOR_ACCOUNT_DETAILS_ERROR";
export const GET_VENDOR_ACCOUNT_DETAILS_RESET =
  "GET_VENDOR_ACCOUNT_DETAILS_RESET";

export const GET_PAYMENT_ADVICE_EXCEL_REPORT =
  "GET_PAYMENT_ADVICE_EXCEL_REPORT";
export const GET_PAYMENT_ADVICE_EXCEL_REPORT_SUCCESS =
  "GET_PAYMENT_ADVICE_EXCEL_REPORT_SUCCESS";
export const GET_PAYMENT_ADVICE_EXCEL_REPORT_ERROR =
  "GET_PAYMENT_ADVICE_EXCEL_REPORT_ERROR";

export function getPOProductListRecord(query) {
  return async (dispatch) => {
    dispatch(getPOProductList());
    return await purchaseOrderService
      .getPOProductList(query)
      .then((response) => dispatch(getPOProductListSuccess(response)))
      .catch((error) => dispatch(getPOProductListError(error)));
  };
}

export function getPOProductList() {
  return {
    type: GET_PO_PRODUCT_LIST,
  };
}

export function getPOProductListSuccess(success) {
  return {
    type: GET_PO_PRODUCT_LIST_SUCCESS,
    payload: { success },
  };
}

export function getPOProductListError(error) {
  return {
    type: GET_PO_PRODUCT_LIST_ERROR,
    payload: { error },
  };
}

export function createPORecord(POData) {
  return async (dispatch) => {
    dispatch(createPO());
    return await purchaseOrderService
      .createPO(POData)

      .then((response) => dispatch(createPOSuccess(response)))
      .catch((error) => dispatch(createPOError(error)));
  };
}

export function createPO() {
  return {
    type: CREATE_PO,
  };
}

export function createPOSuccess(success) {
  return {
    type: CREATE_PO_SUCCESS,
    payload: { success },
  };
}

export function createPOError(error) {
  return {
    type: CREATE_PO_ERROR,
    payload: { error },
  };
}

export function createPOReset() {
  return {
    type: CREATE_PO_RESET,
  };
}

export function getPOListRecord(query) {
  return async (dispatch) => {
    dispatch(getPOList());
    return await purchaseOrderService
      .getPOList(query)
      .then((response) => dispatch(getPOListSuccess(response)))
      .catch((error) => dispatch(getPOListError(error)));
  };
}

export function getPOList() {
  return {
    type: GET_PO_LIST,
  };
}

export function getPOListSuccess(success) {
  return {
    type: GET_PO_LIST_SUCCESS,
    payload: { success },
  };
}

export function getPOListError(error) {
  return {
    type: GET_PO_LIST_ERROR,
    payload: { error },
  };
}

export function getGeneralPOProductListRecord(query) {
  return async (dispatch) => {
    dispatch(getGeneralPOProductList());
    return await purchaseOrderService
      .getGeneralPOProductList(query)
      .then((response) => dispatch(getGeneralPOProductListSuccess(response)))
      .catch((error) => dispatch(getGeneralPOProductListError(error)));
  };
}

export function getGeneralPOProductList() {
  return {
    type: GET_GENERAL_PO_PRODUCT_LIST,
  };
}

export function getGeneralPOProductListSuccess(success) {
  return {
    type: GET_GENERAL_PO_PRODUCT_LIST_SUCCESS,
    payload: { success },
  };
}

export function getGeneralPOProductListError(error) {
  return {
    type: GET_GENERAL_PO_PRODUCT_LIST_ERROR,
    payload: { error },
  };
}

export function getGeneralPOProductListReset() {
  return {
    type: GET_GENERAL_PO_PRODUCT_LIST_RESET,
  };
}

export function getPOProductsByPOIdRecord(query) {
  return async (dispatch) => {
    dispatch(getPOProductsByPOId());
    return await purchaseOrderService
      .getPOProductsByPOId(query)
      .then((response) => dispatch(getPOProductsByPOIdSuccess(response)))
      .catch((error) => dispatch(getPOProductsByPOIdError(error)));
  };
}

export function getPOProductsByPOId() {
  return {
    type: GET_PO_PRODUCTS_BY_PO_ID,
  };
}

export function getPOProductsByPOIdSuccess(success) {
  return {
    type: GET_PO_PRODUCTS_BY_PO_ID_SUCCESS,
    payload: { success },
  };
}

export function getPOProductsByPOIdError(error) {
  return {
    type: GET_PO_PRODUCTS_BY_PO_ID_ERROR,
    payload: { error },
  };
}

export function getPOProductsByPOIdReset() {
  return {
    type: GET_PO_PRODUCTS_BY_PO_ID_RESET,
  };
}

export function getPONoByShopIdRecord(query) {
  return async (dispatch) => {
    dispatch(getPONoByShopId());
    return await purchaseOrderService
      .getPONoByShopId(query)
      .then((response) => dispatch(getPONoByShopIdSuccess(response)))
      .catch((error) => dispatch(getPONoByShopIdError(error)));
  };
}

export function getPONoByShopId() {
  return {
    type: GET_PO_PRODUCTS_BY_SHOP_ID,
  };
}

export function getPONoByShopIdSuccess(success) {
  return {
    type: GET_PO_PRODUCTS_BY_SHOP_ID_SUCCESS,
    payload: { success },
  };
}

export function getPONoByShopIdError(error) {
  return {
    type: GET_PO_PRODUCTS_BY_SHOP_ID_ERROR,
    payload: { error },
  };
}

export function getPONoByShopIdReset() {
  return {
    type: GET_PO_PRODUCTS_BY_SHOP_ID_RESET,
  };
}

export function createReceivePORecord(POData) {
  return async (dispatch) => {
    dispatch(createReceivePO());
    return await purchaseOrderService
      .createReceivePO(POData)

      .then((response) => dispatch(createReceivePOSuccess(response)))
      .catch((error) => dispatch(createReceivePOError(error)));
  };
}

export function createReceivePO() {
  return {
    type: CREATE_RECEIVE_PO,
  };
}

export function createReceivePOSuccess(success) {
  return {
    type: CREATE_RECEIVE_PO_SUCCESS,
    payload: { success },
  };
}

export function createReceivePOError(error) {
  return {
    type: CREATE_RECEIVE_PO_ERROR,
    payload: { error },
  };
}

export function createReceivePOReset() {
  return {
    type: CREATE_RECEIVE_PO_RESET,
  };
}

export function GetPOStoreLocationRecord(query) {
  return async (dispatch) => {
    dispatch(GetPOStoreLocation());
    return await purchaseOrderService
      .GetPOStoreLocation(query)
      .then((response) => dispatch(GetPOStoreLocationSuccess(response)))
      .catch((error) => dispatch(GetPOStoreLocationError(error)));
  };
}

export function GetPOStoreLocation() {
  return {
    type: GET_PO_STORE_LOCATION,
  };
}

export function GetPOStoreLocationSuccess(success) {
  return {
    type: GET_PO_STORE_LOCATION_SUCCESS,
    payload: { success },
  };
}

export function GetPOStoreLocationError(error) {
  return {
    type: GET_PO_STORE_LOCATION_ERROR,
    payload: { error },
  };
}

export function GetPOStoreLocationReset() {
  return {
    type: GET_PO_STORE_LOCATION_RESET,
  };
}

export function getReceivePOListRecord(query) {
  return async (dispatch) => {
    dispatch(getReceivePOList());
    return await purchaseOrderService
      .getReceivePOList(query)
      .then((response) => dispatch(getReceivePOListSuccess(response)))
      .catch((error) => dispatch(getReceivePOListError(error)));
  };
}

export function getReceivePOList() {
  return {
    type: GET_RECEIVE_PO_LIST,
  };
}

export function getReceivePOListSuccess(success) {
  return {
    type: GET_RECEIVE_PO_LIST_SUCCESS,
    payload: { success },
  };
}

export function getReceivePOListError(error) {
  return {
    type: GET_RECEIVE_PO_LIST_ERROR,
    payload: { error },
  };
}

export function updateReceivePORecord(POData) {
  return async (dispatch) => {
    dispatch(updateReceivePO());
    return await purchaseOrderService
      .updateReceivePO(POData)

      .then((response) => dispatch(updateReceivePOSuccess(response)))
      .catch((error) => dispatch(updateReceivePOError(error)));
  };
}

export function updateReceivePO() {
  return {
    type: UPDATE_RECEIVE_PO,
  };
}

export function updateReceivePOSuccess(success) {
  return {
    type: UPDATE_RECEIVE_PO_SUCCESS,
    payload: { success },
  };
}

export function updateReceivePOError(error) {
  return {
    type: UPDATE_RECEIVE_PO_ERROR,
    payload: { error },
  };
}

export function updateReceivePOReset() {
  return {
    type: UPDATE_RECEIVE_PO_RESET,
  };
}

export function getSellerDataShopIdRecord(query) {
  return async (dispatch) => {
    dispatch(getSellerDataShopId());
    return await purchaseOrderService
      .getSellerDataShopId(query)
      .then((response) => dispatch(getSellerDataShopIdSuccess(response)))
      .catch((error) => dispatch(getSellerDataShopIdError(error)));
  };
}

export function getSellerDataShopId() {
  return {
    type: GET_SELLER_DATA_BY_SHOP_ID,
  };
}

export function getSellerDataShopIdSuccess(success) {
  return {
    type: GET_SELLER_DATA_BY_SHOP_ID_SUCCESS,
    payload: { success },
  };
}

export function getSellerDataShopIdError(error) {
  return {
    type: GET_SELLER_DATA_BY_SHOP_ID_ERROR,
    payload: { error },
  };
}

export function getSellerDataShopIdReset() {
  return {
    type: GET_SELLER_DATA_BY_SHOP_ID_RESET,
  };
}

export function createPaymentAdviceRecord(PaymentAdviceData) {
  return async (dispatch) => {
    dispatch(createPaymentAdvice());
    return await purchaseOrderService
      .createPaymentAdvice(PaymentAdviceData)

      .then((response) => dispatch(createPaymentAdviceSuccess(response.data)))
      .catch((error) => dispatch(createPaymentAdviceError(error)));
  };
}

export function createPaymentAdvice() {
  return {
    type: CREATE_PAYMENT_ADVICE,
  };
}

export function createPaymentAdviceSuccess(success) {
  return {
    type: CREATE_PAYMENT_ADVICE_SUCCESS,
    payload: { success },
  };
}

export function createPaymentAdviceError(error) {
  return {
    type: CREATE_PAYMENT_ADVICE_ERROR,
    payload: { error },
  };
}

export function createPaymentAdviceReset() {
  return {
    type: CREATE_PAYMENT_ADVICE_RESET,
  };
}

export function getPaymentAdviceProductsRecord(query) {
  return async (dispatch) => {
    dispatch(getPaymentAdviceProducts());
    return await purchaseOrderService
      .getPaymentAdviceProducts(query)
      .then((response) =>
        dispatch(getPaymentAdviceProductsSuccess(response.data)),
      )
      .catch((error) => dispatch(getPaymentAdviceProductsError(error)));
  };
}

export function getPaymentAdviceProducts() {
  return {
    type: GET_PAYMENT_ADVICE_PRODUCTS,
  };
}

export function getPaymentAdviceProductsSuccess(success) {
  return {
    type: GET_PAYMENT_ADVICE_PRODUCTS_SUCCESS,
    payload: { success },
  };
}

export function getPaymentAdviceProductsError(error) {
  return {
    type: GET_PAYMENT_ADVICE_PRODUCTS_ERROR,
    payload: { error },
  };
}

export function getPaymentAdviceProductsReset() {
  return {
    type: GET_PAYMENT_ADVICE_PRODUCTS_RESET,
  };
}

export function getVendorPaymentDetailsRecord(query) {
  return async (dispatch) => {
    dispatch(getVendorPaymentDetails());
    return await purchaseOrderService
      .getVendorPaymentDetails(query)
      .then((response) =>
        dispatch(getVendorPaymentDetailsSuccess(response.data)),
      )
      .catch((error) => dispatch(getVendorPaymentDetailsError(error)));
  };
}

export function getVendorPaymentDetails() {
  return {
    type: GET_VENDOR_PAYMENT_DETAILS,
  };
}

export function getVendorPaymentDetailsSuccess(success) {
  return {
    type: GET_VENDOR_PAYMENT_DETAILS_SUCCESS,
    payload: { success },
  };
}

export function getVendorPaymentDetailsError(error) {
  return {
    type: GET_VENDOR_PAYMENT_DETAILS_ERROR,
    payload: { error },
  };
}

export function getVendorPaymentDetailsReset() {
  return {
    type: GET_VENDOR_PAYMENT_DETAILS_RESET,
  };
}

export function getPaymentAdviseListRecord(query) {
  return async (dispatch) => {
    dispatch(getPaymentAdviseList());
    return await purchaseOrderService
      .getPaymentAdviseList(query)
      .then((response) => dispatch(getPaymentAdviseListSuccess(response.data)))
      .catch((error) => dispatch(getPaymentAdviseListError(error)));
  };
}

export function getPaymentAdviseList() {
  return {
    type: GET_PAYMENT_ADVICE_LIST,
  };
}

export function getPaymentAdviseListSuccess(success) {
  return {
    type: GET_PAYMENT_ADVICE_LIST_SUCCESS,
    payload: { success },
  };
}

export function getPaymentAdviseListError(error) {
  return {
    type: GET_PAYMENT_ADVICE_LIST_ERROR,
    payload: { error },
  };
}

export function getPaymentAdviseListReset() {
  return {
    type: GET_PAYMENT_ADVICE_LIST_RESET,
  };
}

export function createReturnPORecord(POData) {
  return async (dispatch) => {
    dispatch(createReturnPO());
    return await purchaseOrderService
      .createReturnPO(POData)

      .then((response) => dispatch(createReturnPOSuccess(response)))
      .catch((error) => dispatch(createReturnPOError(error)));
  };
}

export function createReturnPO() {
  return {
    type: CREATE_RETURN_PO,
  };
}

export function createReturnPOSuccess(success) {
  return {
    type: CREATE_RETURN_PO_SUCCESS,
    payload: { success },
  };
}

export function createReturnPOError(error) {
  return {
    type: CREATE_RETURN_PO_ERROR,
    payload: { error },
  };
}

export function createReturnPOReset() {
  return {
    type: CREATE_RETURN_PO_RESET,
  };
}

export function getReturnPOListRecord(query) {
  return async (dispatch) => {
    dispatch(getReturnPOList());
    return await purchaseOrderService
      .getReturnPOList(query)
      .then((response) => dispatch(getReturnPOListSuccess(response.data)))
      .catch((error) => dispatch(getReturnPOListError(error)));
  };
}

export function getReturnPOList() {
  return {
    type: GET_RETURN_PO_LIST,
  };
}

export function getReturnPOListSuccess(success) {
  return {
    type: GET_RETURN_PO_LIST_SUCCESS,
    payload: { success },
  };
}

export function getReturnPOListError(error) {
  return {
    type: GET_RETURN_PO_LIST_ERROR,
    payload: { error },
  };
}

export function getVendorAccountDetailsRecord(query) {
  return async (dispatch) => {
    dispatch(getVendorAccountDetails());
    return await purchaseOrderService
      .getVendorAccountDetails(query)
      .then((response) =>
        dispatch(getVendorAccountDetailsSuccess(response.data)),
      )
      .catch((error) => dispatch(getVendorAccountDetailsError(error)));
  };
}

export function getVendorAccountDetails() {
  return {
    type: GET_VENDOR_ACCOUNT_DETAILS,
  };
}

export function getVendorAccountDetailsSuccess(success) {
  return {
    type: GET_VENDOR_ACCOUNT_DETAILS_SUCCESS,
    payload: { success },
  };
}

export function getVendorAccountDetailsError(error) {
  return {
    type: GET_VENDOR_ACCOUNT_DETAILS_ERROR,
    payload: { error },
  };
}

export function getVendorAccountDetailsReset() {
  return {
    type: GET_VENDOR_ACCOUNT_DETAILS_RESET,
  };
}

export function getApprovalPaymentAdviseListRecord(query) {
  return async (dispatch) => {
    dispatch(getApprovalPaymentAdviseList());
    return await purchaseOrderService
      .getApprovalPaymentAdviseList(query)
      .then((response) =>
        dispatch(getApprovalPaymentAdviseListSuccess(response.data)),
      )
      .catch((error) => dispatch(getApprovalPaymentAdviseListError(error)));
  };
}

export function getApprovalPaymentAdviseList() {
  return {
    type: GET_APPROVAL_PAYMENT_ADVICE_LIST,
  };
}

export function getApprovalPaymentAdviseListSuccess(success) {
  return {
    type: GET_APPROVAL_PAYMENT_ADVICE_LIST_SUCCESS,
    payload: { success },
  };
}

export function getApprovalPaymentAdviseListError(error) {
  return {
    type: GET_APPROVAL_PAYMENT_ADVICE_LIST_ERROR,
    payload: { error },
  };
}

export function getApprovalPaymentAdviseListReset() {
  return {
    type: GET_APPROVAL_PAYMENT_ADVICE_LIST_RESET,
  };
}

// Payment Advice Excel Report start
export function getPaymentAdviceExcelReportRecord(query) {
  return async (dispatch) => {
    dispatch(getPaymentAdviceExcelReport());
    return await purchaseOrderService
      .getPaymentAdviceExcelReport(query)

      .then((response) =>
        dispatch(getPaymentAdviceExcelReportSuccess(response)),
      )
      .catch((error) => dispatch(getPaymentAdviceExcelReportError(error)));
  };
}

export function getPaymentAdviceExcelReport() {
  return {
    type: GET_PAYMENT_ADVICE_EXCEL_REPORT,
  };
}

export function getPaymentAdviceExcelReportSuccess(success) {
  return {
    type: GET_PAYMENT_ADVICE_EXCEL_REPORT_SUCCESS,
    payload: { success },
  };
}

export function getPaymentAdviceExcelReportError(error) {
  return {
    type: GET_PAYMENT_ADVICE_EXCEL_REPORT_ERROR,
    payload: { error },
  };
}

// Payment Advice Excel Report End
